<template>
  <div>
    <ClientBookings v-if="$getConstRole('ROLE_CLIENT') == role"></ClientBookings>
    <AgentBookings v-if="$getConstRole('ROLE_AGENT') == role"></AgentBookings>
    <AdminBookings v-if="$getConstRole('ROLE_ADMIN') == role"></AdminBookings>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ClientBookings from '@/views/client/booking/List.vue'
import AgentBookings from '@/views/agent/booking/List.vue'
import AdminBookings from '@/views/admin/booking/List.vue'

export default {
  name: 'Bookings',
  data: () => ({
    role: 0
  }),
  computed: {
    ...mapGetters(['getCurrentUser']),
  },
  mounted () {
    this.role = this.getCurrentUser.role
  },
  methods: {
  },
  components: {
    AgentBookings,
    ClientBookings,
    AdminBookings
  },
};
</script>
